import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid'
import { Cancel } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Dialog, Box, DialogContent, DialogActions, Button, Divider } from "@mui/material";

// The Dialog box component is an abstracted pop up feature that display table data and the response of API calls
const DialogBox = ({ content, rowsArray = [], columnsArray = [], opener = false, closer, title, isIconTitle = false, responseType = false, isTable = false, dialogWidth, dialogFull = false }) => {

    return (
        <Dialog open={opener} maxWidth={dialogWidth} fullWidth={dialogFull}>
            <DialogContent className='text-center'>
                { isIconTitle && (responseType ? <CheckCircleIcon color="success" style={{ fontSize: "75px" }} /> : <Cancel color="error" style={{ fontSize: '75px' }} />) }
                { isIconTitle && <h3>{ responseType ? "Request Successful" : "Request Error" }</h3> }
                { !isIconTitle && <h3 className='p-2'>{title}</h3> }
                <Divider style={{ margin: '0 0 10px 0' }} />
                {!isTable && <p className='mt-05 mb-2' style={{ textAlign: "left" }}>
                    { content }
                </p>}
                { isTable && 
                     <Box
                     height="80vh"
                     sx={{
                         '& .MuiDataGrid-cellContent': {
                             fontSize: '1.1em',
                         },
                         '& .MuiDataGrid-columnHeaderTitle': {
                             fontSize: '1.1em',
                         },
                     }}
                 >
                     <DataGrid
                         columns={columnsArray}
                         rows={rowsArray}
                     />
                 </Box>
                }
            </DialogContent>
            <DialogActions style={{ padding: '0 1.5rem 1rem' }}>
                <Button onClick={() => { closer(false) }} variant='contained'>Close</Button>
            </DialogActions>
        </Dialog>
    );
};


export default DialogBox;